import styled from 'styled-components';

import Searcher from './Searcher';

export default styled(Searcher)`
  position: relative;

  .searcher-button {
    border: 0;
    width: 20px;
    height: 20px;
    -webkit-appearance: none;
    position: absolute;
    top: 50%;
    padding: 0;
    right: ${(props) => props.theme.base.gridSizes.XS};
    cursor: pointer;
    transform: translateY(-50%);
    z-index: 4;
    outline: none;
    background: transparent;

    svg {
      fill: var(--primary900);
    }

    &.focused {
      svg {
        fill: var(--primary500);
      }
    }

    &__search {
      pointer-events: none;
      cursor: pointer;
    }
  }
`;
